<template>
  <div>
    <div v-if="data && (data.stationId || data.number)" class="flex gap-2">
    <b-form-group
      v-if="data.stationId"
      class="text-sm my-1"
      id="input-group-station"
      label="Post Office Station"
      label-for="input-station">
      <b-form-input
        class="form-text text-sm noFocus"
        type="text"
        disabled="true"
        :value="selectedStationName"
        required>
      </b-form-input>
      <div v-if="selectedStation && selectedStation.description" class="text-xs text-gray-500 mt-1 ml-1">
        {{ selectedStation.description }}
      </div>
    </b-form-group>

    <b-form-group
      v-if="data.number"
      class="text-sm my-1"
      id="input-group-box-number"
      label="P.O. Box Number"
      label-for="input-box-number">
      <b-form-input
        class="form-text text-sm noFocus"
        type="text"
        disabled="true"
        :value="data.number"
        required>
      </b-form-input>
    </b-form-group>
  </div>
  <div v-else class="text-center py-4 text-gray-500 text-sm">
    <p>No postal address information available</p>
  </div>
  </div>
</template>

<script>
import {api} from "../../../../../../../../app/services/api.service";

export default {
  name: 'PostalAddressView',
  props: {
    data: {
      type: Object,
      default: null,
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      stations: [],
      selectedStation: null,
    };
  },
  computed: {
    selectedStationName() {
      if (this.selectedStation && this.selectedStation.branch_name) return this.selectedStation.branch_name;
      if (this.data && this.data.stationId && this.stations.length === 0) return 'Loading...';
      return this.data && this.data.stationId ? '—' : '';
    },
  },
  watch: {
    data: {
      handler(val) {
        if (val && val.stationId && this.stations.length > 0) {
          this.selectedStation = this.stations.find(function (s) { return s.branch_id === val.stationId; }) || null;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchStations();
  },
  methods: {
    fetchStations() {
      var self = this;
      api().get('/integration/api/eposta/stations')
        .then(function (res) {
          if (res.data && res.data.data) {
            self.stations = Array.isArray(res.data.data) ? res.data.data : [];
            if (self.data && self.data.stationId && self.stations.length > 0) {
              self.selectedStation = self.stations.find(function (s) { return s.branch_id === self.data.stationId; }) || null;
            }
          }
        })
        .catch(function () {});
    },
  },
};
</script>

<style scoped>

</style>
